import React from "react";
import "./Upgrade.css";
import greentick from "../../assets/greentick.svg";
import benefitsvideo from "../../assets/benefits.mp4";
const Upgrade = () => {
  const features = [
    {
      title: "NFC Business Card",
      description:
        "Share your business details with a tap via our sustainable NFC-enabled card.",
    },
    {
      title: "Easy Appointment Scheduling",
      description: "Let clients book meetings with you effortlessly.",
    },
    {
      title: "E-Commerce Platform",
      description:
        "Sell your products/services by listing your business at our marketplace.",
    },
    {
      title: "Multi-Platform App",
      description:
        "Build & share your own business website on iOS, Android, & MacBook.",
    },
    {
      title: "More Clients, More Business",
      description: "Expand your network and get new opportunities.",
    },
  ];

  return (
    <div id="upgrade" className="bigwrapper">
      <section className="sectionwrapper">
        <div className="upgradebox">
          <div className="upgradeLeft">
            <h1 className="upgradetitle">
              Upgrade to NFC Cards for <span>Instant Sharing</span> and{" "}
              <span>Zero</span> Paper Waste
            </h1>
            <div className="upgradesubtitle">
              <p className="fup">
                <span className="tilttext">88% </span>
                of Paper Cards End Up in Dustbins{" "}
              </p>
              <i className="fa-solid fa-arrow-right upgradearrow"></i>
              <p>Save Every Lead with NFC Cards</p>
              {/* <p><span className='tilttext'>88%</span> of Paper Cards End Up in Dustbins  <i className="fa-solid fa-arrow-right"></i> Save Every Lead with NFC Cards</p> */}
            </div>
            <ul className="upgradepoints">
              {features.map((feature, index) => (
                <li key={index}>
                  <img src={greentick} alt="tick" className="greentick" />
                  <div className="point">
                    <p className="ptitle">{feature.title}</p>
                    <p className="pdescription">{feature.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="upgradeRight">
            <video
              src={benefitsvideo}
              autoPlay
              loop
              muted
              controls
              className="upgradevideo"
            />
          </div>
        </div>
      </section>
    </div>
  );
};
export default Upgrade;
